import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { ColorTheme } from "../../constants/common";

interface SvgWrapperProps {
    children?: React.ReactNode;
}

export const SvgWrapper = ({ children }: SvgWrapperProps) => (
    <div className={"svg-wrapper"}>{children}</div>
);

export const PermissionIcon = () => {
    return (
        <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.0625 5.25C4.0625 3.80025 5.15381 2.625 6.5 2.625C7.84619 2.625 8.9375 3.80025 8.9375 5.25H4.0625ZM11.375 5.25H10.5625C10.5625 2.83375 8.74366 0.875 6.5 0.875C4.25634 0.875 2.4375 2.83375 2.4375 5.25H1.625C1.17627 5.25 0.8125 5.64175 0.8125 6.125V12.25C0.8125 12.7332 1.17627 13.125 1.625 13.125H11.375C11.8237 13.125 12.1875 12.7332 12.1875 12.25V6.125C12.1875 5.64175 11.8237 5.25 11.375 5.25ZM2.4375 11.375V7H10.5625V11.375H2.4375Z"
                fill="currentColor"
            />
        </svg>
    );
};

export const ChromiumPopupBlockedIcon = () => (
    <SvgWrapper>
        <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="14"
                height="10"
                rx="0.5"
                stroke="currentColor"
            />
            <rect x="1" y="1" width="13" height="2" fill="currentColor" />
            <path d="M1 5H6.5V3" stroke="currentColor" />
            <rect x="11" y="7" width="5" height="5" fill="#D13212" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.6932 8.57215L14.4281 8.30698L13.5 9.23506L12.5719 8.30698L12.3068 8.57215L13.2348 9.50023L12.3068 10.4283L12.5719 10.6935L13.5 9.76539L14.4281 10.6935L14.6932 10.4283L13.7652 9.50023L14.6932 8.57215Z"
                fill="#FFF7F7"
            />
        </svg>
    </SvgWrapper>
);

export const ArrowUpIcon = () => (
    <SvgWrapper>
        <svg
            fill="none"
            width="24"
            height="24"
            viewBox="0 0 28 22"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                transform="rotate(-90 7.5 19.5)"
                x="7.5"
                y="19.5"
                width="16"
                height="16"
                rx="8"
                stroke="currentColor"
            />
            <path
                d="m10.687 12.465.883.883L15.5 9.42l3.929 3.93.883-.884-4.813-4.813-4.812 4.813z"
                clipRule="evenodd"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    </SvgWrapper>
);

export const FirefoxPermissionIcon = () => (
    <SvgWrapper>
        <svg
            width="17"
            height="11"
            viewBox="0 0 17 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1 2.92969H10" stroke="currentColor" />
            <circle
                cx="13.8573"
                cy="2.92857"
                r="1.92857"
                stroke="currentColor"
            />
            <path d="M15.7856 8.07031L6.78565 8.07031" stroke="currentColor" />
            <circle
                cx="2.92861"
                cy="8.07143"
                r="1.92857"
                transform="rotate(180 2.92861 8.07143)"
                stroke="currentColor"
            />
        </svg>
    </SvgWrapper>
);

export const CameraIcon = () => (
    <SvgWrapper>
        <svg
            width="90"
            height="75"
            viewBox="0 0 128 87"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                x1="114.926"
                y1="13.597"
                x2="102.935"
                y2="25.5877"
                stroke="#000716"
                strokeWidth="2"
            />
            <line
                x1="124.423"
                y1="29.6903"
                x2="108.043"
                y2="34.0792"
                stroke="#000716"
                strokeWidth="2"
            />
            <line
                y1="-1"
                x2="16.9574"
                y2="-1"
                transform="matrix(-0.258819 0.965926 0.965926 0.258819 98.384 2.94434)"
                stroke="#000716"
                strokeWidth="2"
            />
            <line
                y1="-1"
                x2="16.9574"
                y2="-1"
                transform="matrix(0.707107 0.707107 0.707107 -0.707107 12.89 12.8899)"
                stroke="#000716"
                strokeWidth="2"
            />
            <line
                y1="-1"
                x2="16.9574"
                y2="-1"
                transform="matrix(0.965926 0.258819 0.258819 -0.965926 2.94446 28.7244)"
                stroke="#000716"
                strokeWidth="2"
            />
            <line
                x1="29.6904"
                y1="2.68552"
                x2="34.0793"
                y2="19.0651"
                stroke="#000716"
                strokeWidth="2"
            />
            <rect
                x="36.9999"
                y="32.9998"
                width="53.0191"
                height="52.2361"
                rx="1"
                fill="#F2F8FD"
                stroke="#000716"
                strokeWidth="2"
            />
            <path
                d="M89.7294 58.3347V52.0231L102.795 44.9745V72.5076L89.7294 65.459V58.3347Z"
                fill="#0972D3"
                stroke="#000716"
                strokeWidth="2"
            />
        </svg>
    </SvgWrapper>
);

export const ExpandDropdownMenuIcon = () => (
    <div className={"expand-dropdown-button-icon"}>
        <ExpandMoreIcon fontSize="inherit" />
    </div>
);

export const AwsIcon = (props: {
    color?: "default" | ColorTheme.DARK | ColorTheme.LIGHT;
}) => {
    let fillColor = "#414d5c";
    if (props.color === ColorTheme.DARK) {
        fillColor = "#000716";
    } else if (props.color === ColorTheme.LIGHT) {
        fillColor = "#fff";
    }
    return (
        <svg
            width="29"
            height="17"
            viewBox="0 0 29 17"
            display="block"
            fill={fillColor}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_533_9882)">
                <path d="M8.17218 6.14831C8.16297 6.43182 8.20017 6.71494 8.28238 6.98698C8.36711 7.21999 8.47188 7.44557 8.59558 7.66131C8.63772 7.72588 8.66172 7.80014 8.66518 7.87664C8.65907 7.93401 8.63905 7.98913 8.60677 8.03742C8.57449 8.08571 8.53089 8.12578 8.47958 8.15431L7.89958 8.55098C7.82454 8.60248 7.736 8.63197 7.64438 8.63598C7.59046 8.63409 7.53749 8.62157 7.48865 8.59918C7.43981 8.57678 7.39611 8.54496 7.36018 8.50564C7.22546 8.37542 7.1085 8.22877 7.01218 8.06931C6.91551 7.91064 6.81691 7.72176 6.71638 7.50264C6.37669 7.91685 5.94452 8.24965 5.45293 8.47555C4.96134 8.70145 4.42336 8.81448 3.88018 8.80598C3.5294 8.82476 3.17832 8.77477 2.84762 8.65896C2.51692 8.54315 2.21327 8.36386 1.95458 8.13165C1.71493 7.89347 1.52834 7.6094 1.40656 7.29732C1.28478 6.98524 1.23044 6.65191 1.24698 6.31831C1.2316 5.95573 1.2997 5.5944 1.44626 5.26095C1.59282 4.9275 1.81409 4.63044 2.09378 4.39164C2.76535 3.87494 3.60664 3.61506 4.46018 3.66064C4.8018 3.66162 5.14292 3.68623 5.48098 3.73431C5.83671 3.78342 6.20598 3.85142 6.58878 3.93831V3.24698C6.6451 2.70519 6.48046 2.16356 6.13058 1.73964C5.68295 1.40334 5.12053 1.24721 4.55878 1.30331C4.20891 1.30504 3.86046 1.34689 3.52058 1.42798C3.16687 1.51062 2.81987 1.61857 2.48238 1.75098C2.37328 1.79996 2.26088 1.84161 2.14598 1.87564H1.99518C1.85985 1.87564 1.79218 1.77742 1.79218 1.58098V1.13331C1.78388 1.01958 1.80797 0.905824 1.86178 0.804645C1.93447 0.71754 2.02813 0.649397 2.13438 0.606311C2.52255 0.424625 2.92873 0.282217 3.34658 0.181311C3.83729 0.0582121 4.34216 -0.00273203 4.84878 -2.19736e-05C5.76 -0.0789243 6.66638 0.195899 7.37178 0.764978C7.65856 1.07841 7.87733 1.44538 8.0149 1.84373C8.15247 2.24208 8.20597 2.66353 8.17218 3.08264V6.14831ZM4.25718 7.58198C4.59731 7.57714 4.93432 7.5178 5.25478 7.40631C5.60803 7.28677 5.92233 7.07749 6.16538 6.79998C6.31512 6.63682 6.42604 6.44331 6.49018 6.23331C6.55695 5.96635 6.58815 5.69208 6.58298 5.41731V5.02064C6.29033 4.95212 5.9941 4.89915 5.69558 4.86198C5.3955 4.82447 5.0933 4.80554 4.79078 4.80531C4.28286 4.7681 3.77723 4.9021 3.35818 5.18498C3.20682 5.31544 3.08716 5.47723 3.00789 5.65859C2.92863 5.83994 2.89176 6.03628 2.89998 6.23331C2.88627 6.41433 2.91058 6.59618 2.97142 6.76769C3.03226 6.9392 3.12835 7.09674 3.25378 7.23065C3.38921 7.35074 3.54753 7.44358 3.7197 7.50386C3.89186 7.56415 4.0745 7.59069 4.25718 7.58198ZM12.0002 8.60198C11.8695 8.61365 11.7387 8.58169 11.629 8.51131C11.5263 8.41028 11.4558 8.28234 11.426 8.14298L9.16978 0.855645C9.126 0.732759 9.09681 0.605369 9.08278 0.475978C9.07786 0.444364 9.08062 0.412063 9.09083 0.381682C9.10104 0.351301 9.11842 0.323691 9.14156 0.301079C9.16471 0.278468 9.19297 0.261489 9.22406 0.251512C9.25516 0.241535 9.28822 0.23884 9.32058 0.243645H10.266C10.3986 0.230655 10.5317 0.262672 10.643 0.334311C10.739 0.438422 10.805 0.565508 10.8344 0.702645L12.4526 6.93598L13.9548 0.702645C13.978 0.565103 14.0449 0.438203 14.1462 0.339978C14.2624 0.269888 14.3987 0.238107 14.5348 0.249311H15.312C15.4481 0.238107 15.5843 0.269888 15.7006 0.339978C15.8008 0.440477 15.8658 0.56944 15.8862 0.708311L17.4 7.02098L19.0704 0.708311C19.1012 0.570497 19.1693 0.443289 19.2676 0.339978C19.3789 0.268339 19.512 0.236322 19.6446 0.249311H20.5378C20.5701 0.244507 20.6032 0.247202 20.6343 0.257179C20.6654 0.267156 20.6937 0.284135 20.7168 0.306746C20.7399 0.329357 20.7573 0.356968 20.7675 0.387349C20.7777 0.41773 20.7805 0.45003 20.7756 0.481645C20.7804 0.530643 20.7804 0.57998 20.7756 0.628978C20.7571 0.707687 20.7338 0.785265 20.706 0.861311L18.386 8.14865C18.3562 8.28801 18.2857 8.41595 18.183 8.51698C18.0733 8.58735 17.9424 8.61932 17.8118 8.60765H16.965C16.8278 8.62168 16.6901 8.58753 16.5764 8.51131C16.4769 8.40584 16.4122 8.27354 16.3908 8.13165L14.8886 2.06264L13.4038 8.12598C13.3823 8.26787 13.3177 8.40018 13.2182 8.50564C13.1045 8.58187 12.9667 8.61602 12.8296 8.60198H12.0002ZM24.389 8.85131C23.8892 8.85212 23.3911 8.79698 22.9042 8.68698C22.5169 8.61082 22.1422 8.48307 21.7906 8.30731C21.6848 8.26356 21.5948 8.19012 21.5318 8.0963C21.4688 8.00248 21.4357 7.89251 21.4368 7.78031V7.30431C21.4368 7.10787 21.5102 7.00964 21.6572 7.00964C21.7187 7.01054 21.7796 7.02205 21.837 7.04364L22.0806 7.13998C22.421 7.28715 22.7769 7.39737 23.142 7.46865C23.5236 7.54525 23.9124 7.58322 24.302 7.58198C24.7925 7.61038 25.2812 7.50231 25.7114 7.27031C25.8684 7.17917 25.9975 7.04855 26.0852 6.89206C26.1729 6.73558 26.2161 6.55897 26.2102 6.38065C26.2135 6.25964 26.1921 6.1392 26.1473 6.02635C26.1025 5.9135 26.0351 5.81048 25.9492 5.72331C25.6564 5.48361 25.3111 5.31298 24.94 5.22465L23.5422 4.79398C22.9536 4.63419 22.4293 4.30193 22.04 3.84198C21.7291 3.45144 21.5597 2.97107 21.5586 2.47631C21.5505 2.11061 21.6405 1.7492 21.8196 1.42798C21.9929 1.12582 22.2278 0.861595 22.5098 0.651645C22.8054 0.432025 23.1395 0.266883 23.4958 0.164311C23.8897 0.0532427 24.298 -0.0020975 24.708 -2.19736e-05C24.9252 -0.000208863 25.1421 0.0130399 25.3576 0.0396447C25.578 0.0660891 25.7868 0.101978 25.984 0.147311C26.1812 0.192645 26.3648 0.241756 26.535 0.294645C26.675 0.33756 26.8109 0.392554 26.941 0.458978C27.0508 0.516838 27.1475 0.595877 27.2252 0.691311C27.2865 0.783897 27.3169 0.892795 27.3122 1.00298V1.45064C27.3122 1.64709 27.2387 1.74531 27.0918 1.74531C26.9618 1.73112 26.8357 1.69265 26.7206 1.63198C26.1353 1.38359 25.5026 1.25995 24.8646 1.26931C24.4208 1.24677 23.9788 1.33862 23.5828 1.53564C23.4344 1.6203 23.3131 1.74353 23.2322 1.8916C23.1513 2.03967 23.114 2.20678 23.1246 2.37431C23.1217 2.49896 23.1455 2.62282 23.1944 2.73796C23.2434 2.85311 23.3164 2.957 23.4088 3.04298C23.7214 3.2873 24.083 3.46489 24.4702 3.56431L25.839 3.96664C26.4186 4.11383 26.9386 4.4301 27.3296 4.87331C27.6362 5.26219 27.796 5.7426 27.782 6.23331C27.7871 6.6125 27.6996 6.98742 27.5268 7.32698C27.3579 7.65136 27.1183 7.93568 26.825 8.15998C26.5052 8.40126 26.1409 8.58018 25.752 8.68698C25.3081 8.8055 24.849 8.86085 24.389 8.85131Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.2102 13.4924C23.0376 15.7817 18.4324 17 14.5 17C9.19442 17.0342 4.06766 15.128 0.1276 11.6564C-0.1682 11.3957 0.0927997 11.0387 0.4524 11.237C4.82324 13.6798 9.77198 14.9633 14.8074 14.96C18.5678 14.9403 22.2872 14.195 25.752 12.767C26.2856 12.546 26.738 13.1127 26.2102 13.4924Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.5326 12.019C27.1266 11.509 24.8472 11.781 23.8264 11.9C23.519 11.934 23.4668 11.6733 23.7452 11.4806C25.5606 10.234 28.5418 10.591 28.884 11.0103C29.2262 11.4296 28.7912 14.348 27.0918 15.742C26.8308 15.9573 26.5814 15.844 26.6974 15.5606C27.0802 14.62 27.9386 12.529 27.5326 12.019Z"
                />
            </g>
            <defs>
                <clipPath id="clip0_533_9882">
                    <rect width="29" height="17" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
